import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Loader2Icon } from 'lucide-react';
interface LoginScreenProps {
  onLogin: () => void;
}
export function LoginScreen({
  onLogin
}: LoginScreenProps) {
  const [step, setStep] = useState<'email' | 'code'>('email');
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const handleSendCode = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setStep('code');
    }, 800);
  };
  const handleVerify = (e: React.FormEvent) => {
    e.preventDefault();
    if (!code.trim()) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      onLogin();
    }, 600);
  };
  return <div className="h-screen w-full bg-geniac-bg flex items-center justify-center font-sans" data-id="element-204">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="w-full max-w-md mx-4" data-id="element-205">
        <div className="bg-geniac-panel/60 border border-geniac-border rounded-2xl px-10 py-12 backdrop-blur-sm" data-id="element-206">
          {/* Logo */}
          <h1 className="text-center mb-10" data-id="element-207">
            <span className="text-3xl font-bold text-geniac-text" data-id="element-208">Geniac</span>
            <span className="text-3xl font-bold text-geniac-accent" data-id="element-209">.io</span>
          </h1>

          <AnimatePresence mode="wait" data-id="element-210">
            {step === 'email' ? <motion.form key="email" initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: 10
          }} onSubmit={handleSendCode} className="space-y-5" data-id="element-211">
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email" className="w-full bg-geniac-bg/50 border border-geniac-border rounded-lg px-4 py-3.5 text-sm text-geniac-text placeholder-geniac-muted focus:outline-none focus:ring-1 focus:ring-geniac-accent focus:border-geniac-accent" autoFocus data-id="element-212" />
                <button type="submit" disabled={!email.trim() || loading} className="w-full py-3.5 rounded-lg bg-geniac-accent text-geniac-bg font-semibold text-base transition-all hover:bg-geniac-accent/90 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-213">
                  {loading ? <Loader2Icon className="w-5 h-5 animate-spin" data-id="element-214" /> : 'Send Code'}
                </button>
                <p className="text-center text-sm text-geniac-muted" data-id="element-215">
                  We'll send a 6-digit verification code to your email.
                </p>
              </motion.form> : <motion.form key="code" initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: 10
          }} onSubmit={handleVerify} className="space-y-5" data-id="element-216">
                <p className="text-center text-sm text-geniac-muted mb-2" data-id="element-217">
                  Code sent to{' '}
                  <span className="text-geniac-text font-medium" data-id="element-218">{email}</span>
                </p>
                <input type="text" value={code} onChange={e => setCode(e.target.value)} placeholder="Enter 6-digit code" maxLength={6} className="w-full bg-geniac-bg/50 border border-geniac-border rounded-lg px-4 py-3.5 text-sm text-geniac-text placeholder-geniac-muted focus:outline-none focus:ring-1 focus:ring-geniac-accent focus:border-geniac-accent text-center tracking-[0.3em] text-lg" autoFocus data-id="element-219" />
                <button type="submit" disabled={!code.trim() || loading} className="w-full py-3.5 rounded-lg bg-geniac-accent text-geniac-bg font-semibold text-base transition-all hover:bg-geniac-accent/90 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-220">
                  {loading ? <Loader2Icon className="w-5 h-5 animate-spin" data-id="element-221" /> : 'Verify'}
                </button>
                <button type="button" onClick={() => {
              setStep('email');
              setCode('');
            }} className="w-full text-center text-sm text-geniac-muted hover:text-geniac-text transition-colors" data-id="element-222">
                  Use a different email
                </button>
              </motion.form>}
          </AnimatePresence>
        </div>
      </motion.div>
    </div>;
}